// extracted by mini-css-extract-plugin
module.exports = {"labels-layout":"_7a3fb80146--labels-layout--v_EuM","label":"_7a3fb80146--label--DZaI2","title":"_7a3fb80146--title--NzAX1"};